import React from 'react'

export const QrcodeScanView = () => {
  return (
    <div>QrcodeScanView</div>
  )
}
